export function parseDataAttributes(elem) {
    let props = {};
    let value = null;
    for (let key in elem.dataset) {
        if (!elem.dataset.hasOwnProperty(key)) continue;
        value = elem.dataset[key];
        if (!value) continue;
        try {
            props[key] = JSON.parse(value);
        } catch (e) {
            props[key] = value;
        }
    }
    return props;
}